import * as React from "react";
import { Container, Box, Typography, Divider, List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TermsPage() {
  const { t, i18n } = useTranslation();
  const lastUpdated = new Date().toLocaleDateString(i18n.language);

  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, sm: 6 } }}>
      <Typography variant="h3" sx={{ fontWeight: 700, letterSpacing: -0.5 }}>
        {t("legal.terms.title")}
      </Typography>
      <Typography sx={{ color: "text.secondary", mt: 1 }}>
        {t("legal.common.lastUpdated")} {lastUpdated}
      </Typography>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography>
          {t("legal.terms.intro")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.legalEntity.title")}
        </Typography>
        <Typography>
          {t("legal.terms.sections.legalEntity.body")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.service.title")}
        </Typography>
        <Typography>
          {t("legal.terms.sections.service.body")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.accounts.title")}
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary={t("legal.terms.sections.accounts.bullets.confidentiality")} />
          </ListItem>
          <ListItem>
            <ListItemText primary={t("legal.terms.sections.accounts.bullets.accurateInfo")} />
          </ListItem>
          <ListItem>
            <ListItemText primary={t("legal.terms.sections.accounts.bullets.noMisuse")} />
          </ListItem>
        </List>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.subscription.title")}
        </Typography>
        <Typography>
          {t("legal.terms.sections.subscription.body")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.acceptableUse.title")}
        </Typography>
        <Typography>
          {t("legal.terms.sections.acceptableUse.body")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.availability.title")}
        </Typography>
        <Typography>
          {t("legal.terms.sections.availability.body")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.liability.title")}
        </Typography>
        <Typography>
          {t("legal.terms.sections.liability.body")}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {t("legal.terms.sections.contact.title")}
        </Typography>
        <Typography>
          {t("legal.common.contact", { email: "contact@kehilati.com" })}
        </Typography>
      </Box>
    </Container>
  );
}

